import { ReactNode } from 'react';

import { Col, ColProps, Space } from 'antd';
import Row, { Gutter } from 'antd/es/grid/row';

import styled, { StyledProp } from '@/styled';

import SkeletonBaseCard from '../SkeletonBaseCard';

const DEFAULT_ROWS_SPACING = [16, 16] as [Gutter, Gutter];

const DEFAULT_COLUMNS_WIDTH: Pick<ColProps, 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'> = {
  xs: 24,
  sm: 12,
  md: 12,
  lg: 8,
  xl: 6,
  xxl: 6
};

interface IListCoursesProps {
  isFetching: boolean;
  isPaginated?: boolean;
  children: ReactNode[];
  pagination?: {
    totalRows: number;
    totalPages: number;
    pageSize: number;
    page: number;
  };
}

interface IListCoursesStyleProps {
  marginTop?: number;
}

const HorizontalList = ({
  isFetching,
  className,
  children,
  isPaginated = false,
  pagination
}: IListCoursesStyleProps & StyledProp & IListCoursesProps) => {
  if (isPaginated && !pagination) {
    throw new Error('Pagination should be defined when list is paginated');
  }

  const numberOfFetchingElements = isPaginated
    ? Math.min(pagination.totalRows, Math.max(pagination.totalRows - pagination.page * pagination.pageSize, 0))
    : null;

  return (
    <div className={className} id='horizontal-list'>
      {(!isFetching || isPaginated) && (
        <>
          <Row gutter={DEFAULT_ROWS_SPACING}>
            <>
              {children?.map((child, index) => (
                <Col {...DEFAULT_COLUMNS_WIDTH} key={`horizontal-list-${index}`}>
                  {child}
                </Col>
              ))}
              {isFetching &&
                new Array(pagination.page ? numberOfFetchingElements : 8).fill('').map((_, index) => (
                  <Col {...DEFAULT_COLUMNS_WIDTH} key={index}>
                    <SkeletonBaseCard aspect='16:9' />
                  </Col>
                ))}
            </>
          </Row>
        </>
      )}
      {isFetching && !isPaginated && (
        <Space direction='vertical' className='skeleton-container-listcourses'>
          <Row gutter={DEFAULT_ROWS_SPACING}>
            {new Array(8).fill('').map((_, index) => (
              <Col {...DEFAULT_COLUMNS_WIDTH} key={index}>
                <SkeletonBaseCard aspect='16:9' />
              </Col>
            ))}
          </Row>
        </Space>
      )}
    </div>
  );
};

export default styled(HorizontalList)`
  z-index: 0;
  position: relative;
  margin-top: ${props => props.marginTop || 0}px;

  .skeleton-container-listcourses {
    width: 100%;
  }

  .ant-select {
    min-width: 150px;
  }
`;
